import React from "react";
import { BiBlock } from "react-icons/bi";
import PropTypes from "prop-types";

export default function BBlockButton({ onBlock, btnText }) {
  return (
    <button
      onClick={onBlock}
      className="ml-4 py-1 px-3 rounded-md shadow-md bg-yellow-600 text-white flex items-center cursor-pointer hover:bg-yellow-500 transition-all focus:shadow-outline focus:outline-none"
      type="submit"
    >
      <BiBlock className="mr-1" />
      {btnText}
    </button>
  );
}

BBlockButton.propTypes = {
  onDelete: PropTypes.func.isRequired,
  btnText: PropTypes.string,
};
